import { useQuery } from '@apollo/client'
import { Divider, Space, Typography } from 'antd'
import { GET_ACTIVITIES } from '../../Graphql/queries/getQueries'
import HeaderComp from '../HeaderComp/HeaderComp'
import Spiner from '../Spiner/Spiner'

const LeadActivities = ({ leadId }) => {
    const { error, loading, data } = useQuery(GET_ACTIVITIES, {
        variables: {
            lead_id: leadId
        },
    })

    const activities = data?.Activities.nodes.map((item, i) => {
        return {
            id: i,
            date: item.date,
            label: <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
        }
    })
    if (loading) return <Spiner />
    return (
        <div className='lead_comp_container flex_ver' style={{ maxHeight: 1130, overflowY: 'scroll' }}>
            <HeaderComp title="Activities" />
            {activities?.map((activity) => (
                <Space key={activity.id} direction="vertical" size="middle" style={{ display: 'flex' }}>
                    <Typography.Title level={5}>{activity.date} </Typography.Title>
                    <Typography.Text >{activity.label} </Typography.Text>
                    <Divider />
                </Space>
            ))}
        </div>
    )
}

export default LeadActivities